import { forwardRef } from 'react';
import { clsx } from '@team/clsx';
import { ImageBase } from '../image-base';
import { AvatarInitials } from './components/initials';
import { hasInitials } from './lib/has-initials';
import { Props } from './types';
import css from './style.module.css';

export const Layout = forwardRef<HTMLDivElement, Props>(function Component(
  { className, size = 40, initials, fallback, ...props },
  forwardedRef
) {
  return (
    <ImageBase
      {...props}
      className={clsx(className, css.root, {
        [css.withInitials]: hasInitials(initials),
      })}
      size={size}
      fallback={
        <AvatarInitials size={size} initials={initials} fallback={fallback} />
      }
      ref={forwardedRef}
    />
  );
});
